import { IResponsibleFilterProps } from '../../types';
import { useQuery } from 'react-query';
import {
  getAllResponsibleByLicenseAsync,
  getAllResponsibleCountByLicenseAsync,
} from '../../index';
import { IPaginationParams } from '../../../types';
import { getUserId } from '../../../DefaultService';

const USER_ID = getUserId();

export const useGetAllResponsibleByLicenseAsync = (
  pagination: IPaginationParams,
  filter: IResponsibleFilterProps,
) =>
  useQuery([`responsible${pagination.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllResponsibleByLicenseAsync(pagination, filter),
  });

export const useGetAllResponsibleByLicenseCountAsync = (
  pagination: IPaginationParams,
  filter: IResponsibleFilterProps,
) =>
  useQuery([`responsibleCount${pagination.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllResponsibleCountByLicenseAsync(filter),
  });
